/**
 * Mock 模块：heart_voyage_relation_list
 * 默认 1 条限时情侣给 RelationTypeModal（不藏情侣卡）。
 * 抽屉预览传 pair_key 时走 WithLimit（3 行）/ 无 pair 以外的 NoLimit 仅导出。
 * @see mockMd/heart_voyage_relation_list.md
 */
import {
  RelationType,
  type ActivityMemberV2,
  type RelationListData,
} from '../types'
import {storiesAvatar} from '../components/RelationListDrawer/stories-images'

const MOCK_SELF: ActivityMemberV2 = {
  id: 10001,
  name: 'username',
  zy_id: '123456',
  avatar: storiesAvatar,
  gender: 1,
}

const MOCK_SELF_PEER = (
  id: number,
  name: string
): RelationListData['list'][number]['peer'] => ({
  id,
  name,
  zy_id: String(id),
  avatar: storiesAvatar,
  gender: 1,
})

/** @see mockMd/heart_voyage_relation_list.md · 示例为限时情侣（source=2），不藏情侣卡 */
export const HeartVoyageRelationListMock: RelationListData = {
  err_msg: '',
  stage: 2,
  has_limit_relation: true,
  show_switch_relation: true,
  self: MOCK_SELF,
  list: [
    {
      pair_key: '10001:10002',
      relation_source: 2,
      relation_type: RelationType.Couple,
      peer: {
        id: 10002,
        name: 'Bob',
        zy_id: '654321',
        avatar: 'https://example.com/b.png',
        gender: 1,
      },
      affinity: 5000,
      ship_level: 3,
      ship_form: 2,
    },
  ],
}

/** 对齐 state-with-limit：端内兄弟 + 限时兄弟(Unbind) + 端内情侣当前 */
export const HeartVoyageRelationListWithLimitMock: RelationListData = {
  err_msg: '',
  stage: 2,
  has_limit_relation: true,
  show_switch_relation: true,
  self: MOCK_SELF,
  list: [
    {
      pair_key: '10001:10003',
      relation_source: 1,
      relation_type: RelationType.Brother,
      peer: MOCK_SELF_PEER(10003, 'username'),
      affinity: 1200,
      ship_level: 299,
      ship_form: 2,
    },
    {
      pair_key: '10001:10004',
      relation_source: 2,
      relation_type: RelationType.Brother,
      peer: MOCK_SELF_PEER(10004, 'username'),
      affinity: 800,
      ship_level: 299,
      ship_form: 2,
    },
    {
      pair_key: '10001:10002',
      relation_source: 1,
      relation_type: RelationType.Couple,
      peer: MOCK_SELF_PEER(10002, 'username'),
      affinity: 5000,
      ship_level: 299,
      ship_form: 2,
    },
  ],
}

/** 对齐 state-no-limit：2 条端内 + 空余位 */
export const HeartVoyageRelationListNoLimitMock: RelationListData = {
  err_msg: '',
  stage: 2,
  has_limit_relation: false,
  show_switch_relation: true,
  self: MOCK_SELF,
  list: [
    {
      pair_key: '10001:10003',
      relation_source: 1,
      relation_type: RelationType.Brother,
      peer: MOCK_SELF_PEER(10003, 'username'),
      affinity: 1200,
      ship_level: 299,
      ship_form: 2,
    },
    {
      pair_key: '10001:10002',
      relation_source: 1,
      relation_type: RelationType.Couple,
      peer: MOCK_SELF_PEER(10002, 'username'),
      affinity: 5000,
      ship_level: 299,
      ship_form: 2,
    },
  ],
}
